// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "switch__container_disable-2Ib5S";
export { _1 as "__esModule", _2 as "switch__container_disable" }
export default { "__esModule": _1, "switch__container_disable": _2 }
